import type { WritingAssistSaveSelection } from 'components/WritingAssist';

export interface WritingAssistApplicationResult {
  application: any;
  baseCoverLetterUpdated: boolean;
  baseCoverLetterError?: unknown;
}

interface SubmitWritingAssistApplicationOptions {
  hireJobId: number;
  selection: WritingAssistSaveSelection;
  createApplication: (payload: { hireJobId: number; coverLetter: string }) => Promise<any>;
  updateBaseCoverLetter: (payload: { baseCoverLetter: string }) => Promise<unknown>;
}

/**
 * The application is the primary, gate-protected transaction. The optional
 * profile update is intentionally second so a coach/block response cannot
 * partially change the profile and a secondary failure can never trigger a
 * duplicate application retry.
 */
export async function submitWritingAssistApplication({
  hireJobId,
  selection,
  createApplication,
  updateBaseCoverLetter,
}: SubmitWritingAssistApplicationOptions): Promise<WritingAssistApplicationResult> {
  const application = await createApplication({
    hireJobId,
    coverLetter: selection.text,
  });

  if (!selection.saveAsBase) {
    return { application, baseCoverLetterUpdated: false };
  }

  try {
    await updateBaseCoverLetter({ baseCoverLetter: selection.text });
    return { application, baseCoverLetterUpdated: true };
  } catch (baseCoverLetterError) {
    return { application, baseCoverLetterUpdated: false, baseCoverLetterError };
  }
}
